var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateCleaningDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8442 32.5833L22.5208 27.9067L27.1975 32.5833L29.2292 30.5517L24.5525 25.875L29.2292 21.1983L27.1975 19.1667L22.5208 23.8433L17.8442 19.1667L15.8125 21.1983L20.4892 25.875L15.8125 30.5517L17.8442 32.5833ZM36.4167 5.74999H34.5V1.91666H30.6667V5.74999H15.3333V1.91666H11.5V5.74999H9.58333C7.45583 5.74999 5.76917 7.47499 5.76917 9.58332L5.75 36.4167C5.75 38.525 7.45583 40.25 9.58333 40.25H36.4167C38.525 40.25 40.25 38.525 40.25 36.4167V9.58332C40.25 7.47499 38.525 5.74999 36.4167 5.74999ZM36.4167 36.4167H9.58333V15.3333H36.4167V36.4167Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8442 32.5833L22.5208 27.9067L27.1975 32.5833L29.2292 30.5517L24.5525 25.875L29.2292 21.1983L27.1975 19.1667L22.5208 23.8433L17.8442 19.1667L15.8125 21.1983L20.4892 25.875L15.8125 30.5517L17.8442 32.5833Z",
    fill: "#FF5C39",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCleaningDue);
export default __webpack_public_path__ + "static/media/dateCleaningDue.a2ade5a8369a93f27f831f94746d685b.svg";
export { ForwardRef as ReactComponent };